<template>
  <layout>
    <img
      v-if="brokerLogo"
      class="mx-auto my-6 h-11 w-auto md:hidden"
      :src="brokerLogo"
      alt="broker logo"
    />
    <h1 class="header-text">On Hold</h1>
    <p class="mb-6 text-dark-gray md:mb-8">
      <span>
        Unfortunately, {{ broker?.legal_name }} has a hold in place for
        {{ dispatcherSelectedCarrierId ? 'this carrier' : companyName }}. For
        more information, please contact {{ broker?.legal_name }}
        directly at
      </span>
      <a
        class="text-link underline"
        href="mailto:{{supportEmail}}"
      >
        {{ supportEmail }}
      </a>
    </p>
    <button-main @click="$router.push(routeLink)">
      {{ linkText }}
      <img
        class="link-icon inline"
        src="@/assets/link-icon.svg"
        alt=""
      />
    </button-main>
  </layout>
</template>

<script>
import Layout from '../layouts/HoldingTankLayout.vue';
import Button from '../Button.vue';

export default {
  name: 'Do Not Dispatch',
  components: {
    'button-main': Button,
    Layout,
  },
  props: {
    companyType: String,
    companyName: String,
    supportEmail: String,
    brokerLogo: String,
  },
  computed: {
    linkText() {
      return this.companyType === 'carrier'
        ? 'Go to Carrier Portal'
        : 'Go to Dispatch Service Portal';
    },
    routeLink() {
      return this.companyType === 'carrier'
        ? '/carrier/brokers'
        : '/dispatcher';
    },
    broker() {
      return this.$store.state.company?.company;
    },
    dispatcherSelectedCarrierId() {
      return this.$store.state.dispatchers.selectedCarrierId;
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}
.text-link {
  color: #e7b812;
}

.link-icon {
  position: relative;
  bottom: 1px;
}
</style>
